import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Autocomplete,
  Typography,
  FormControl,
  Menu,
  MenuItem,
} from "@mui/material";
import styles from "../PieChart.module.scss";
import { convertDateYYYYMMDD, MyModal } from "../../../utility";
import ModalContainer from "../../../components/modal_popup";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { JobsDashboardFilterActions } from "../../../redux-store/store";
import { getJobFilterOptions } from "../../../apiServices";

const JobCategoryChartFilter = () => {
  const JobsFilter = useSelector(
    (state) => state.JobsDashboardFilterDetails.JobsDashboard
  );

  const Dispatch = useDispatch("");
  const initialObject = {
    companyName: JobsFilter.companyName,
    jobCity: JobsFilter.jobCity,
    startDate: JobsFilter.startDate,
    endDate: JobsFilter.endDate,
  };

  const [Jobopen, setJobopen] = useState(false);
  const [filters, setFilters] = useState(initialObject);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [options, setOptions] = useState({
    city: "",
  });
  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);

  const create = useSelector(
    (state) => state.JobsDashboardFilterDetails.JobsDashboard.startDate
  );
  const ended = useSelector(
    (state) => state.JobsDashboardFilterDetails.JobsDashboard.endDate
  );
  const [showCustom, setshowCustom] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [dateRange, setDateRange] = useState({
    start: JobsFilter.startDate,
    end: JobsFilter.endDate,
    dateFilterType: JobsFilter.dateFilterType,
  });
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });
  useEffect(() => {
    getJobFilterOptions().then((data) => {
      const cityOptions = data.filter((element) => element.category === "city");

      setOptions((prev) => ({
        ...prev,
        city: cityOptions,
      }));
      //console.log(cityOptions);
    });
  }, []);
  // useEffect(() => {
  //   console.log(JobsFilter, "JobsFilter");
  // }, [JobsFilter]);
  const jobCategories = [
    "Software Engineer",
    "Product Manager",
    "Designer",
    "Data Analyst",
    "Marketing Specialist",
  ];

  function handleJobClose() {
    setJobopen(false);
  }
  const handleClose = (val) => {
    //console.log(val);

    setAnchorEl(null);
  };
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };
  const updateCity = (event, value) => {
    const selectedCity = event?.options || "";

    setFilters({ ...filters, jobCity: selectedCity });
  };

  const handleClearAll = () => {
    setFilters({
      companyName: "",
      jobCity: "",
    });
    setDateRange({
      start: null,
      end: null,
      dateFilterType: "",
    });

    Dispatch(
      JobsDashboardFilterActions.setJobsDashboardFilter({
        ...initialObject,
        startDate: "2023-01-01",
        endDate: convertDateYYYYMMDD(new Date()),
      })
    );
    setSelectedFilters(null);
  };
  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "currentMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 2);
      endDate = today;
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "lastMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 2);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);

      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: convertDateYYYYMMDD(endDate),
      }));
      console.log(dateRange.end, "fff");
    } else if (val === "custom") {
      // Custom date range: Show custom date picker
      setshowCustom(true);
    }

    setAnchorEl(null);
  };

  function handleCustomDate(value, type) {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  }

  const isFormValid = () => {
    // Implement your validation logic here
    // For example, you can check if both start and end dates are filled
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApply = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      // Your submit logic here
      // Proceed with form submission
      //console.log("Form submitted:", dateRange);
      setValidationErrors({
        start: false,
        end: false,
      });
      setshowCustom(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Filters:", filters);
    Dispatch(
      JobsDashboardFilterActions.setJobsDashboardFilter({
        ...filters,
        startDate: dateRange.start || create,
        endDate: dateRange.end || ended,
        dateFilterType: dateRange.dateFilterType || "",
      })
    );
    setSelectedFilters(filters);
    handleJobClose();
  };

  return (
    <div className={styles.filterContainer}>
      <div>
        <button
          className="btn btn-success"
          onClick={() => {
            setJobopen(true);
          }}
        >
          Filter
        </button>
      </div>
      <div className="d-flex justify-content-center align-items-center"></div>
      {Jobopen && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div style={{ width: 400 }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div variant="h6" gutterBottom>
                      <b>Filter</b>
                    </div>
                    <div>
                      <button
                        className="btn btn-danger"
                        onClick={handleJobClose}
                      >
                        <AiOutlineClose />
                      </button>
                    </div>
                  </div>
                  <div>
                    <TextField
                      label="Company Name"
                      fullWidth
                      value={filters.companyName}
                      onChange={(e) =>
                        handleFilterChange("companyName", e.target.value)
                      }
                      margin="normal"
                    />
                  </div>
                  <div>
                    <Autocomplete
                      id="tags-outlined"
                      options={options.city.map((option) => option)}
                      getOptionLabel={(option) => `${option.options}`}
                      onChange={(event, value, reason) => {
                        if (reason === "clear") {
                          console.log("Selection cleared");
                          updateCity("");
                        } else {
                          updateCity(value);
                          //console.log(value, "value jobs");
                        }
                      }}
                      value={{
                        options: filters.jobCity ? filters.jobCity : "",
                        category: "city",
                      }}
                      fullWidth
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="City"
                          placeholder="City"
                        />
                      )}
                    />
                  </div>

                  <div>
                    <FormControl variant="outlined" fullWidth>
                      <TextField
                        label="Created on"
                        id="basic-button"
                        value={`${dateRange.dateFilterType}`}
                        // value={`${dateRange.start} - ${dateRange.end}`}
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        className="mt-2"
                      ></TextField>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            handleDateSelect("currentMonth");
                          }}
                          style={{ width: "400px" }}
                        >
                          Current Month
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleDateSelect("lastMonth");
                          }}
                        >
                          Last Month
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleDateSelect("custom");
                          }}
                        >
                          Custom Date/Month
                        </MenuItem>
                      </Menu>
                    </FormControl>

                    {showCustom && (
                      <MyModal>
                        <ModalContainer
                          zIndex={1005}
                          childComponent={
                            <div
                              style={{
                                minWidth: "400px",
                                width: "auto",
                              }}
                            >
                              <>
                                <div>
                                  <form>
                                    <p className="text-center ">
                                      Select Custom Date{" "}
                                    </p>
                                    <div className="mt-2">
                                      <label htmlFor="start">From</label>
                                      <input
                                        className={`form-control ${
                                          validationErrors.start
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        style={{ width: "100%" }}
                                        type="date"
                                        id="start"
                                        onChange={(value) =>
                                          handleCustomDate(value, "startDate")
                                        }
                                        name="trip-start"
                                        min="2020-01-01"
                                        max={
                                          new Date().toISOString().split("T")[0]
                                        }
                                      />
                                      {validationErrors.start && (
                                        <div className="invalid-feedback">
                                          Start date is required.
                                        </div>
                                      )}
                                    </div>
                                    <div className="mt-2">
                                      <label htmlFor="end">To</label>
                                      <input
                                        className={`form-control ${
                                          validationErrors.end
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        style={{ width: "100%" }}
                                        type="date"
                                        id="end"
                                        onChange={(value) =>
                                          handleCustomDate(value, "endDate")
                                        }
                                        name="trip-end"
                                        min="2020-01-01"
                                        max={
                                          new Date().toISOString().split("T")[0]
                                        }
                                      />
                                      {validationErrors.end && (
                                        <div className="invalid-feedback">
                                          End date is required.
                                        </div>
                                      )}
                                    </div>
                                    <div className="d-flex justify-content-end mt-3 ">
                                      <button
                                        onClick={() => {
                                          setValidationErrors({
                                            start: false,
                                            end: false,
                                          });
                                          setshowCustom(false);
                                        }}
                                        style={{
                                          backgroundColor: "#b2261c",
                                        }}
                                        className="btn rounded-pill text-white px-4  me-2"
                                      >
                                        Close
                                      </button>
                                      <button
                                        onClick={handleApply}
                                        // color="primary"
                                        className="btn rounded-pill text-white px-4"
                                        style={{
                                          backgroundColor: "#169C50",
                                        }}
                                      >
                                        Apply
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </>
                            </div>
                          }
                        />
                      </MyModal>
                    )}
                  </div>
                  <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleClearAll}
                      sx={{ mt: 2 }}
                    >
                      Clear All
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success"
                      sx={{ mt: 2, mr: 1 }}
                      onClick={handleSubmit}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
    </div>
  );
};

export default JobCategoryChartFilter;
